import React from 'react'
import { Column } from "react-table";

export default [
    { 
        Header: 'Salon',
        accessor: 'name',
        width: '50%',
    },
    { 
        Header: 'Type',
        accessor: 'type',
        width: '50%',
        Cell: ({ value }) => <span style={{ textTransform: "capitalize" }}>{value}</span>
    },
    {
        Header: <span title="Members">Mem.</span>,
        accessor: 'members_count',
        width: 25
    },
    { 
        Header: <span title="Acceptances">Acc.</span>,
        accessor: 'acceptances_count',
        width: 25
    },
    { 
        Header: <span title="Awards">Aw.</span>,
        accessor: 'awards_count',
        width: 25
    }
] as Column<Club.Resources.SalonPartial>[]